<template>
    <div class="clientcabin clientcabin-premium">
        <v-container>
            <v-row justify="center">
                <v-col
                    cols="12"
                    lg="9"
                    xl="7"
                    class="py-6 py-md-10 text-subtitle-1"
                >
                    <p class="headline text-center my-4">
                        USA Today Publishing: The Secret To Getting AI & Google
                        To Recommend Your Brand
                    </p>
                    <p class="text-h4 text-center">
                        We Get You Published On World-Renowned Business & News
                        Brands Like USA Today, Business Insider, The Associated
                        Press & More To Boost Reputation, Organic Traffic &
                        Sales
                    </p>
                </v-col>
            </v-row>
        </v-container>
        <div class="blueish">
            <v-container>
                <v-row justify="center">
                    <v-col cols="12" lg="9" xl="7" class="py-6 py-md-10">
                        <p class="subheadline text-center">Get Seen On:</p>
                        <v-container class="get-seen-on">
                            <v-row>
                                <v-col
                                    cols="6"
                                    md="3"
                                    class="d-flex justify-center align-center"
                                >
                                    <v-icon size="160">
                                        $vuetify.icons.UsaTodayColorLogo
                                    </v-icon>
                                </v-col>
                                <v-col
                                    cols="6"
                                    md="3"
                                    class="d-flex justify-center align-center"
                                >
                                    <v-icon size="140">
                                        $vuetify.icons.BusinessInsiderColorLogo
                                    </v-icon>
                                </v-col>
                                <v-col
                                    cols="6"
                                    md="3"
                                    class="d-flex justify-center align-center"
                                >
                                    <v-icon size="160">
                                        $vuetify.icons.BarchartColorLogo
                                    </v-icon>
                                </v-col>
                                <v-col
                                    cols="6"
                                    md="3"
                                    class="d-flex justify-center align-center"
                                >
                                    <v-icon size="160">
                                        $vuetify.icons.BenzingaColorLogo
                                    </v-icon>
                                </v-col>
                                <v-col
                                    cols="6"
                                    md="3"
                                    class="d-flex justify-center align-center"
                                >
                                    <v-icon size="160">
                                        $vuetify.icons.MediumColorLogo
                                    </v-icon>
                                </v-col>
                                <v-col
                                    cols="6"
                                    md="3"
                                    class="d-flex justify-center align-center"
                                >
                                    <v-icon size="180">
                                        $vuetify.icons.StreetInsiderColorLogo
                                    </v-icon>
                                </v-col>
                                <v-col
                                    cols="6"
                                    md="3"
                                    class="d-flex justify-center align-center"
                                >
                                    <v-icon size="160">
                                        $vuetify.icons.TheStreetColorLogo
                                    </v-icon>
                                </v-col>
                                <v-col
                                    cols="6"
                                    md="3"
                                    class="d-flex justify-center align-center"
                                >
                                    <v-icon size="100">
                                        $vuetify.icons.ApNewsColorLogo
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <v-container>
            <v-row justify="center">
                <v-col
                    cols="12"
                    lg="9"
                    xl="7"
                    class="py-6 py-md-10 text-subtitle-1"
                >
                    <p>
                        Have you ever wondered why some businesses are able to
                        charge several times more than their competition?
                    </p>
                    <p>
                        Or why some businesses are always busy or fully booked
                        up, no matter what the economy is doing?
                    </p>
                    <p class="font-weight-bold">
                        The answer is BRAND STRENGTH & MARKET AUTHORITY.
                    </p>
                    <p>
                        Their brands carry enough authority to be the #1 choice
                        in their market, rain or shine
                    </p>
                    <p>That is our expertise.</p>
                    <p>
                        And it’s more important to invest in Brand Strength now
                        than it’s ever been – as times are changing.
                    </p>
                </v-col>
            </v-row>
        </v-container>
        <div class="clientcabin-darkblue">
            <v-container>
                <v-row justify="center">
                    <v-col
                        cols="12"
                        lg="9"
                        xl="7"
                        class="py-6 py-md-10 white--text text-subtitle-1"
                    >
                        <p class="subheadline text-center pb-6 my-4">
                            The Uncomfortable Truth: AI & Brand Strength Now
                            Determine Who Wins Online
                        </p>
                        <p>
                            Today, when people have questions, they go to
                            platforms like Google, YouTube and ChatGPT.
                        </p>
                        <p>
                            Each of these platforms (and countless others) have
                            one thing in common…
                        </p>
                        <p>
                            They trust and prioritize content from trusted and
                            recognized brands.
                        </p>
                        <p>It can take decades to build a brand like this.</p>
                        <p>
                            Fortunately – there is a way to speed up the
                            process.
                        </p>
                        <p>
                            When you get published on sites like USA Today and
                            Business Insider...
                        </p>
                        <p class="font-weight-bold">
                            You Inherit Their Authority.
                        </p>
                        <p>You become a trusted source.</p>
                        <p>
                            Huge sites like Google, YouTube and ChatGPT start
                            sending you more traffic.
                        </p>
                        <p>
                            And potential customers see you as a reputable
                            company worth doing business with.
                        </p>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <v-container>
            <v-row justify="center">
                <v-col cols="12" lg="9" xl="7" class="py-6 text-subtitle-1">
                    <v-img
                        class="elevation-3 rounded-lg mb-8"
                        src="@/assets/img/clientcabin/premium/images/1.png"
                    />
                    <p class="font-weight-bold mt-2 px-4 text-center">
                        The Way People Find You Online Has Changed – You MUST
                        Become A Trusted Authority In Your Market In Order To
                        Become The Business That Wins The AI Answer Box
                    </p>
                </v-col>
            </v-row>
        </v-container>
        <div class="clientcabin-darkblue">
            <v-container>
                <v-row justify="center">
                    <v-col
                        cols="12"
                        lg="9"
                        xl="7"
                        class="py-6 py-md-10 white--text text-subtitle-1"
                    >
                        <p class="subheadline text-center pb-6 my-4">
                            CASE STUDY: Mobile Home Transporter Becomes State
                            Authority In 48 Hours
                        </p>
                        <p>
                            We recently helped a mobile home moving company in
                            Florida become the #1 trusted market source in their
                            state with Google, YouTube and AI platforms like
                            ChatGPT and Perplexity AI.
                        </p>
                        <p class="font-weight-bold">
                            Here's What Happened Within 48 Hours Of Publishing:
                        </p>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <v-container>
            <v-row justify="center">
                <v-col cols="12" lg="9" xl="7" class="py-6 text-subtitle-1">
                    <v-img
                        class="elevation-3 rounded-lg mb-8"
                        src="@/assets/img/clientcabin/premium/images/2.png"
                    />
                    <p class="font-weight-bold mt-2 px-4 text-center">
                        Within Days Of Publishing Their Campaign & Getting Seen
                        On USA Today This Moving Company Took Over Google’s AI
                        Answers & Became The Go-To Authority In Their Market
                    </p>
                    <p class="font-weight-bold">
                        The Compound Effect Of Brand Strength & Authority Is
                        Massive…
                    </p>
                    <ul>
                        <li>Higher search rankings (often overnight)</li>
                        <li>AI platforms cite you as a trusted source</li>
                        <li>Search Engines rank your content</li>
                        <li>Social algorithms recommend your posts</li>
                        <li>
                            Potential customers see you as the obvious choice
                        </li>
                    </ul>
                    <p>
                        This is what happens when you get published on sites
                        like USA Today, Business Insider, The Associated Press
                        and more of the most trusted sites in the world.
                    </p>
                </v-col>
            </v-row>
        </v-container>
        <div class="clientcabin-darkblue">
            <v-container>
                <v-row justify="center">
                    <v-col
                        cols="12"
                        lg="9"
                        xl="7"
                        class="py-6 py-md-10 white--text text-subtitle-1"
                    >
                        <p class="subheadline text-center pb-6 my-4">
                            We Get Your Business Seen On World-Renowned 7-8
                            Figure Traffic Websites
                        </p>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <v-container>
            <v-row justify="center">
                <v-col
                    cols="12"
                    lg="9"
                    xl="7"
                    class="py-6 py-md-10 text-subtitle-1"
                >
                    <v-img
                        class="elevation-3 rounded-lg mb-8"
                        src="@/assets/img/clientcabin/premium/USAToday.png"
                    />
                    <v-img
                        class="elevation-3 rounded-lg mb-8"
                        src="@/assets/img/clientcabin/premium/BusinessInsider.png"
                    />
                    <v-img
                        class="elevation-3 rounded-lg mb-8"
                        src="@/assets/img/clientcabin/premium/Barchart.png"
                    />
                    <v-img
                        class="elevation-3 rounded-lg mb-8"
                        src="@/assets/img/clientcabin/premium/Benzinga.png"
                    />
                    <v-img
                        class="elevation-3 rounded-lg mb-8"
                        src="@/assets/img/clientcabin/premium/Medium.png"
                    />
                    <v-img
                        class="elevation-3 rounded-lg mb-8"
                        src="@/assets/img/clientcabin/premium/StreetInsider.png"
                    />
                    <v-img
                        class="elevation-3 rounded-lg mb-8"
                        src="@/assets/img/clientcabin/premium/TheStreet.png"
                    />
                    <v-img
                        class="elevation-3 rounded-lg mb-8"
                        src="@/assets/img/clientcabin/premium/AssociatedPress.png"
                    />
                </v-col>
            </v-row>
        </v-container>
        <div class="clientcabin-darkblue white--text">
            <v-container>
                <v-row justify="center">
                    <v-col
                        cols="12"
                        lg="9"
                        xl="7"
                        class="py-6 py-md-10 text-subtitle-1"
                    >
                        <p class="subheadline text-center pb-6 my-4">
                            Google Trusts These Sites So Much The Content Gets
                            Preferred Treatment
                        </p>
                        <p>
                            Google gives content published on these sites much
                            more exposure.
                        </p>
                        <p>
                            They rank quickly and can start driving traffic and
                            sales often within hours.
                        </p>
                        <p>
                            AI Platforms and other algorithms pick this up
                            immediately.
                        </p>
                        <p class="font-weight-bold">
                            5 Ways This Can Grow Your Business:
                        </p>
                        <ol>
                            <li>
                                <b>Instant Reputation Management</b>
                                – When prospects Google your name, they see
                                world-renowned brands talking about you. Game
                                over – you win.
                            </li>
                            <li>
                                <b>Search Engine Domination</b>
                                – These high-authority sites rank immediately so
                                your content appears on page one within hours,
                                not months.
                            </li>
                            <li>
                                <b>AI Answer Authority</b>
                                – ChatGPT, Google AI, and Perplexity cite your
                                content as the trusted source when people ask
                                questions in your field.
                            </li>
                            <li>
                                <b>Competitive Advantage</b>
                                – While competitors struggle with algorithm
                                changes, you're using the brands algorithms
                                already trust.
                            </li>
                            <li>
                                <b>Premium Positioning</b>
                                – Association with these major brands justifies
                                higher prices and positions you as the go-to
                                expert.
                            </li>
                        </ol>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <v-container>
            <v-row justify="center">
                <v-col
                    cols="12"
                    lg="9"
                    xl="7"
                    class="py-6 py-md-10 text-subtitle-1"
                >
                    <p class="subheadline text-center pb-6 my-4">
                        What Makes "USA Today" So Special?
                    </p>
                    <p>
                        All the sites we publish to are powerful 7-8 figure
                        traffic mega brands with massive trust from search
                        engines, social networks and AI platforms.
                    </p>
                    <p class="font-weight-bold">
                        However, USA Today is special, because…
                    </p>
                    <ul class="pb-4">
                        <li>
                            <b>USA Today</b>
                            lets you post blog content vs. strict news articles
                            which is more engaging
                        </li>
                        <li>
                            <b>USA Today</b>
                            lets you publish "rich posts" to include video and
                            images with subheadings
                        </li>
                        <li>
                            <b>USA Today</b>
                            trains the YouTube algorithm to bring related
                            visitors to your channel
                        </li>
                        <li>
                            <b>USA Today</b>
                            consistently ranks high in Google and is a trusted
                            source for its AI Answers
                        </li>
                        <li>
                            <b>USA Today</b>
                            is a preferred authority source of information for
                            Google and Perplexity.ai
                        </li>
                    </ul>
                    <p>
                        Combined with the other huge sites we publish to, we can
                        actual influence how your customers find you by getting
                        various “AI Answers” to recommend you.
                    </p>
                    <v-img
                        class="elevation-3 rounded-lg mb-8"
                        src="@/assets/img/clientcabin/premium/images/3.png"
                    />
                </v-col>
            </v-row>
        </v-container>
        <div class="clientcabin-darkblue">
            <v-container>
                <v-row justify="center">
                    <v-col
                        cols="12"
                        lg="9"
                        xl="7"
                        class="py-6 py-md-10 white--text text-subtitle-1"
                    >
                        <p class="subheadline text-center pb-6 my-4">
                            CASE STUDY: Home Fitness eCom Store Trains AI To
                            Recommend Their Products
                        </p>
                        <p>
                            We helped a small fitness equipment eCom store
                            influence AI to recommend its own-branded products
                            against multi-billion dollar competitors.
                        </p>
                        <p class="font-weight-bold">
                            Here’s what happened within days of publishing:
                        </p>
                        <ul>
                            <li>
                                <b>Google AI Overview:</b>
                                Featured their content as the #1 source for a
                                comparison search…
                            </li>
                            <li>
                                <b>ChatGPT:</b>
                                Referenced their article when users asked for
                                equipment recommendations…
                            </li>
                            <li>
                                <b>Perplexity AI:</b>
                                Listed their company as the top authority on the
                                topic…
                            </li>
                        </ul>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <v-container>
            <v-row justify="center">
                <v-col cols="12" lg="9" xl="7" class="py-6">
                    <v-img
                        class="elevation-3 rounded-lg mb-8"
                        src="@/assets/img/clientcabin/premium/images/4.png"
                    />
                </v-col>
            </v-row>
        </v-container>
        <div class="blueish">
            <v-container>
                <v-row justify="center">
                    <v-col cols="12" lg="9" xl="7" class="py-6 py-md-10">
                        <p class="font-weight-bold text-center">
                            By ‘Inheriting’ The Authority Of Sites Like USA
                            Today We Can Influence Google & Other AI On How To
                            Answer People’s Questions About Your Products &
                            Services
                        </p>
                        <p class="text-center">
                            You can have multiple 8-figure traffic sites and
                            world-famous brands talking about you, starting
                            today.
                        </p>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <v-container>
            <v-row justify="center">
                <v-col cols="12" lg="9" xl="7" class="py-6 py-md-10">
                    <p class="font-weight-bold text-center text-subtitle-1">
                        Once Your Payment Is Complete We'll Gather Some
                        Information About Your Business & Get To Work Making You
                        The #1 Choice In Your Market.
                    </p>
                    <p class="text-center text-h5">Select Your Option Below</p>
                    <v-container class="clientcabin-pricing">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-card elevation="10" class="rounded-lg">
                                    <v-img
                                        class="black--text align-center grey lighten-4"
                                        min-height="160px"
                                    >
                                        <div
                                            class="text-center option-title pa-4 mt-4"
                                        >
                                            Option 1
                                            <span class="option-plan">
                                                Plan 1
                                            </span>
                                            <br />
                                            <b>Single Purchase @</b>
                                        </div>
                                    </v-img>
                                    <div class="price text-center">
                                        {{
                                            reseller_client_premium_amp_credit_price
                                        }}
                                    </div>
                                    <v-card-text class="text-center">
                                        <v-btn
                                            x-large
                                            color="primary white--text"
                                            :block="
                                                $vuetify.breakpoint.smAndDown
                                            "
                                            class="px-10 py-8 text-h6 rounded-lg"
                                            @click="onOrder('single')"
                                        >
                                            Add to cart
                                        </v-btn>
                                    </v-card-text>
                                    <v-card-text class="pt-0 text-center">
                                        <v-icon class="mr-1">
                                            $vuetify.icons.secure
                                        </v-icon>
                                        <v-icon large class="mr-1">
                                            $vuetify.icons.mastercard
                                        </v-icon>
                                        <v-icon large class="mr-1">
                                            $vuetify.icons.amex
                                        </v-icon>
                                        <v-icon large class="mr-1">
                                            $vuetify.icons.visa
                                        </v-icon>
                                        <v-icon large>
                                            $vuetify.icons.paypal
                                        </v-icon>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-card elevation="10" class="rounded-lg">
                                    <v-img
                                        class="black--text align-center grey lighten-4"
                                        min-height="160px"
                                    >
                                        <div
                                            class="text-center mt-n5 primary white--text text-button"
                                        >
                                            Most Popular
                                        </div>
                                        <div
                                            class="text-center option-title pa-4"
                                        >
                                            Option 2
                                            <span class="option-plan">
                                                Plan 2
                                            </span>
                                            <br />
                                            <b>Monthly Purchase @</b>
                                        </div>
                                    </v-img>
                                    <div class="price text-center">
                                        {{
                                            reseller_client_recurring_premium_amp_credit_price
                                        }}
                                    </div>
                                    <v-card-text class="text-center">
                                        <v-btn
                                            x-large
                                            color="primary white--text"
                                            :block="
                                                $vuetify.breakpoint.smAndDown
                                            "
                                            class="px-10 py-8 text-h6 rounded-lg"
                                            @click="onOrder('recurring')"
                                        >
                                            Add to cart
                                        </v-btn>
                                    </v-card-text>
                                    <v-card-text class="pt-0 text-center">
                                        <v-icon class="mr-1">
                                            $vuetify.icons.secure
                                        </v-icon>
                                        <v-icon large class="mr-1">
                                            $vuetify.icons.mastercard
                                        </v-icon>
                                        <v-icon large class="mr-1">
                                            $vuetify.icons.amex
                                        </v-icon>
                                        <v-icon large class="mr-1">
                                            $vuetify.icons.visa
                                        </v-icon>
                                        <v-icon large>
                                            $vuetify.icons.paypal
                                        </v-icon>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

import { InjectReactive } from '@/utils/decorators';

import type { ClientCabin } from '@/types/ClientCabin';

@Component
export default class Premium extends Vue {
    endpoint = '/reseller_sales_pages/premium';

    @InjectReactive({
        from: 'options',
        default() {
            return false;
        }
    })
    options!: Partial<ClientCabin> | null;

    get reseller_client_premium_amp_credit_price() {
        return this.format(
            this.options?.reseller_client_premium_amp_credit_price
        );
    }

    get reseller_client_recurring_premium_amp_credit_price() {
        return `${this.format(
            this.options?.reseller_client_recurring_premium_amp_credit_price
        )}/mo`;
    }

    format(price?: number) {
        if (price) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: this.options?.currency || 'USD',
                maximumFractionDigits: 0
            }).format(price);
        }

        return price;
    }

    onOrder(product: 'single' | 'recurring') {
        this.$http
            .post(this.endpoint, {
                [product]: 1
            })
            .then(({ data }) => {
                if (data.data.success) {
                    this.onSuccess(data.data);
                }
            });
    }

    onSuccess({ redirect }: { redirect?: string }) {
        if (redirect) {
            // payment page
            window.location.href = redirect;
        }
    }
}
</script>

<style lang="scss" scoped>
.clientcabin-premium::v-deep {
    background-color: $white;
    color: $black;

    .get-seen-on {
        .v-icon,
        svg {
            max-height: 100px !important;
        }
    }

    .option-title {
        font-size: 1.25rem;
        line-height: 1.8em;
        text-transform: uppercase;

        .option-plan {
            border: 2px solid grey;
            padding: 4px 8px;
            margin-left: 8px;
            font-weight: 600;
        }
    }

    .price {
        font-weight: 700;
        font-size: 67px;
        letter-spacing: -1px;
        text-align: center;
        padding: 25px 0;
        color: $black;
    }
}
</style>
